import { Injectable } from '@angular/core';
import {  Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TabCommunicationService {
    private channel = new BroadcastChannel('transport-order-changed-channel');
    changedDateSubject = new Subject<string>();

    constructor() {
        this.channel.onmessage = (event) => {
            this.changedDateSubject.next(event.data);
        };
    }

    sendMessage(msg: string) {
        this.channel.postMessage(msg);
    }
}
